import 'react-dates/lib/css/_datepicker.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DatePickerUI from '../src/AccommodationUI/date_picker';
import PeopleInputUI from '../src/AccommodationUI/people_input';
import GenderInputUI from '../src/AccommodationUI/gender_input';
import { initAccommodations } from '../src/AccommodationUI/accommodations/index.ts';

const renderDatePicker = () => {
  const dom = document.getElementById('date-picker');
  if (dom) {
    ReactDOM.render(<DatePickerUI />, dom as HTMLElement);
  }
}

const renderPeopleInput = () => {
  const dom = document.getElementById('people-input');
  if (dom) {
    ReactDOM.render(<PeopleInputUI />, dom as HTMLElement);
  }
}

const renderGenderInput = () => {
  const dom = document.getElementById('gender-input');
  if (dom) {
    ReactDOM.render(<GenderInputUI />, dom as HTMLElement);
  }
}

document.addEventListener('turbolinks:load', () => {
  initAccommodations();
  renderDatePicker();
  renderPeopleInput();
  renderGenderInput();
});
